export default __webpack_public_path__ + "static/image-highlight-vps-report-c96f63a04937b3bbcbcc2d30afa11619.png";